import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../tasks/baseFormComponent/baseForm.component';
import {
  Component,
  OnInit,
  Optional,
  ElementRef,
  OnDestroy,
  AfterContentInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DocumentDTO, MasterDataDTO, getSimpleIdentifierFromString, I18nData } from '../api/plyca-dtos';
import { FormConfig } from '../components/forms/form.objects';
import { Configuration } from '../conf/app.constants';
import * as lodash from 'lodash';

import { HelpService, HelpType } from '../components/common/help/help.service';
import { AppConfiguration } from '../conf/app.configuration';

import { DebtInquiriesDTO, ResultTypeDTO } from '../api/plyca-dtos-v2';
import { Observable, of } from 'rxjs';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog/public_api';
import { MessageDTOModal } from '../components/message.component';
import { showcontentComponent } from '../components/showcontent.component';


export class DebtInquiriesModel {

  dto: DebtInquiriesDTO;
  ui: {
    isContextWork?: boolean,
    isEnvioTesoreria?: boolean,
    isEnvioTribunal?: boolean,
    sendTo?: MasterDataDTO;
    processIdentifier?: string;
  }
}

@Component({
  selector: 'debtinquiries-form',
  templateUrl: '../tasks/baseFormComponent/baseForm.template.html'
})
export class DebtInquiriesComponent
  extends BaseFormComponent<DebtInquiriesDTO, DebtInquiriesModel>
  implements OnInit, OnDestroy, AfterContentInit {

  private identifier: string;


  infoLoaded = false;

  projectLoaded = false;
  existProject = false;


  public static resetChange(changes?: any) {
    let oldValue = changes.oldValue;
    let newValue = changes.newValue;

    let reset = ((oldValue && newValue) && (oldValue.identifier !== newValue.identifier)) || (newValue === undefined);
    console.log('======resetChange', reset);
    return reset;
  }


  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,
    public helpService: HelpService
  ) {
    super(elem);
    //this.helpService.showContextHelp(HelpType.NEW_CONTRACT);
    this.waitService.cancelWaiting();

  }

  ngAfterContentInit(): void {
    // this.createRejectionPanel();
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'integration/checkDebtTreasuryInterfaceSettings.json';
  }



  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'debtinquiries/';
    //return this.configuration.DEBTINQUIRIES_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task) {
      identifier = undefined;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nuevo contrato
      identifier = 'new';
    }
    return identifier;
  }

  dtoToModel(dto: DebtInquiriesDTO): Observable<DebtInquiriesModel> {
    let model = new DebtInquiriesModel();
    model.dto = dto;
    model.ui = {
      isContextWork: false
    };
    if (this.task !== undefined) {
      if (this.task.work) {
        if (this.task.work.debtInquiries === undefined) {
          this.uiService.showMessage(
            'Se ha producido un error en la carga de datos de la pantalla. ' +
            'Consulte con el administrador. ',
            'Aviso',
            'errorStyle'
          );
        }
        model.dto = this.task.work.debtInquiries;
      }
    }

    if (model.dto.process) {
      model.ui.processIdentifier = getSimpleIdentifierFromString(model.dto.process.identifier);
    }

    let modelObs: Observable<DebtInquiriesModel>;
    modelObs = of(model);
    return modelObs;
  }



  modelToDTO(model: DebtInquiriesModel): DebtInquiriesDTO {


    model.dto = JSON.parse(
      JSON.stringify(model.dto, (k, v) => (k === '_parent' ? undefined : v))
    );


    if (this.task) {
      this.task.work.debtInquiries = model.dto;
    }
    return model.dto;
  }



  // getProjectId(): string {
  //   return this.model.dto.project.identifier;
  // }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    if (this.model && this.model.dto && this.model.dto.sendToAEAT) {
      headerInfo.titleKey = 'Consulta de deuda a la Agencia Tributaria';
    } else if (this.model && this.model.dto && this.model.dto.sendToAEAT) {
      headerInfo.titleKey = 'Consulta de deuda a la Tesorería General de la Seguridad Social';
    } else {
      headerInfo.titleKey = 'Consulta de deuda';
    }
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }




  initHeaderActions() {

    this.subscribe(this.headerActionsService
      .addAction('Consultar', 'fas fa-save', 'btn-primary', true)
      , (
        () => {
          if (this.task !== undefined) {


            this.subscribe(this.saveIfValid(true),
              _model => {
                if (_model.work && _model.work.debtInquiries && _model.work.debtInquiries.identifier) {
                  this.model.dto.identifier = _model.work.debtInquiries.identifier;

                  let msgRespuesta = _model.work.debtInquiries.response;

                  let helpContent = '<div class="col-12 alert alert-info"><p>Se realizó la consulta CSP correctamente.</p><p>Resultado de la consulta:<b><ul><i class="fa fa-check text-success"></i> '
                    + msgRespuesta + '</b></ul><ul><i class="fa fa-check text-success"></i> Se ha creado un documento con los datos de la respuesta del servicio CSP.</ul></p></div>';
                  let styleClass = 'successStyle';
                  this.showContent(helpContent, 'Consulta Deuda', styleClass);
                }



              });
          }
        }));

    this.headerActionsService.addDivider();
    this.addBack();
  }


  showContent(
    message: string | I18nData,
    titleKey?: string | I18nData,
    styleClass?: string
  ): DynamicDialogRef {
    let context = new MessageDTOModal(message, titleKey);
    // messageData: string | I18nData, titleKey?: string | I18nData) {
    // let config: any = ServiceLocator.injector.get(DynamicDialogConfig);
    let config: DynamicDialogConfig = {
      header: context.title,
      width: '50%',
      height: '50%',
      style: { overflow: 'scroll' },
      styleClass: styleClass,

      baseZIndex: 500
    };
    config['context'] = context;

    const ref = this.dialogService.open(showcontentComponent, config);
    return ref;
  }

  validateInfo() {
    this.subscribe(this.validate(true),
      (result => {
        if (result.result === ResultTypeDTO.OK) {
          this.uiService.showMessage(
            'Se ha validado correctamente.',
            'Aviso',
            'errorStyle'
          );
        }
      }))
  }

  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        this.salir();
      }));
  }


  salir() {
    this.uiService.routeBack();
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {

    return super.configureFormConfig(formConfig);
  }



  getDocument(): DocumentDTO {
    try {
      return this.model.dto['document'];
    } catch { }
  }



}
